import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import RoleBasedRoute from "utils/route-guard/RoleBasedRoute";
import { AccountBalance } from "@mui/icons-material";

// Dashboard
const Dashboard = Loadable(
  lazy(() => import("views/forms/Dashboard/Dashboard"))
);

// project Milestone 
const AccountDashboard = Loadable(lazy(() => import("views/forms/AccountDashboard/Index")))
const PortfolioDashboard = Loadable(lazy(() => import("views/forms/PortfolioDashboard/Portfolio")))

const UpdateProfile = Loadable(lazy(() => import("views/application/Index")))
const AddProject = Loadable(lazy(() => import("views/forms/AccountDashboard/AddEditProject")))



// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    // {
    //   path: "/dashboard",
    //   element: <Dashboard />,
    // },
    {
      path: "/account-dashboard",
      element: (
        <AccountDashboard />
      ),
    },
    {
      path: "/add-project",
      element: <AddProject />,
    },
    {
      path: "/edit-project/:projectId",
      element: <AddProject />,
    },
    {
      path: "/update-profile",
      element: <UpdateProfile />,
    },
    {
      path: "/portfolio",
      element: <PortfolioDashboard />,
    },

  ],
};

export default MainRoutes;
